import type { CareerTierId } from '@crowdfpl/domain/gamification';

export const CAREER_TIER_ORDER = [
  'rookie',
  'scout',
  'punter',
  'gaffer',
  'mastermind',
  'legend',
] as const satisfies readonly CareerTierId[];

const TIER_LABELS: Record<CareerTierId, string> = {
  rookie: 'Rookie',
  scout: 'Scout',
  punter: 'Punter',
  gaffer: 'Gaffer',
  mastermind: 'Mastermind',
  legend: 'Legend',
};

export function formatCareerTierLabel(tier: CareerTierId): string {
  return TIER_LABELS[tier];
}

export function getCareerTierIndex(tier: CareerTierId): number {
  return CAREER_TIER_ORDER.indexOf(tier);
}
